import { render } from "./AssessTransfer.vue?vue&type=template&id=c7fc7b40&scoped=true"
import script from "./AssessTransfer.vue?vue&type=script&lang=js"
export * from "./AssessTransfer.vue?vue&type=script&lang=js"

import "./AssessTransfer.vue?vue&type=style&index=0&id=c7fc7b40&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7fc7b40"]])

export default __exports__